// Company / legal information used in Impressum, Datenschutz, footer etc.
// Update this single file whenever business details change.
export const COMPANY = {
  legalName: "Uzus Immobilien UG (haftungsbeschränkt)",
  street: "Marienburger Str. 5",
  zip: "45665",
  city: "Recklinghausen",
  country: "Deutschland",
  email: "uzus.immobilien@gmail.com",
  phone: "", // optional — fill when ready
  managingDirector: "Bilal Uzunay",
  registerCourt: "Amtsgericht Recklinghausen",
  registerNumber: "HRB 11627",
  vatId: "", // USt-IdNr (optional)
  taxNumber: "—", // Steuernummer (provide later)
  brand: "qrmenu-pro.com",
  domain: "qrmenu-pro.com",
  appUrl: "https://qrmenu-pro.com",
  supportEmail: "uzus.immobilien@gmail.com",
  // Public-facing contact channels (used by Navbar Instagram, Contact section, Footer)
  instagramHandle: "qr.menu.pro",
  instagramUrl: "https://instagram.com/qr.menu.pro",
  publicEmail: "uzus.immobilien@gmail.com",
};
